<script setup lang="ts">
import { ref } from 'vue'
import { getVueAssetImagePath } from '@/lib/utils'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'
import type { PageContent } from '@/assets/ts/pages/shipment-protection-shipping'
import type { BannerTab } from '@/lib/insurance'

const props = defineProps<{
	pageContent: PageContent
	theme?: 'shopping' | 'shipping'
}>()

const emit = defineEmits<{
	(e: 'banner-tab-click', tab: BannerTab): void
}>()

const { pageContent, theme = 'shopping' } = props
const currentTab = ref(theme)

const updateTab = (tab: BannerTab) => {
	currentTab.value = tab
	emit('banner-tab-click', tab)
}
</script>

<template>
	<div
		class="relative flex w-full flex-col gap-casual-friends overflow-hidden bg-o-50 px-20px pt-distant-acquaintances mdp:px-32px"
		:class="[
			currentTab === 'shipping' ? 'bg-o-50' : 'bg-t-50',
			!pageContent.banner.toggle.shopping ? 'py-distant-acquaintances' : '',
		]"
	>
		<div class="flex flex-col gap-8px lg:gap-12px">
			<div
				class="typography-h1-str text-center"
				v-html="pageContent.banner.title"
			/>

			<div class="typography-b1-reg text-center text-n-800">
				{{ pageContent.banner.description }}
			</div>
		</div>

		<div
			v-if="pageContent.banner.toggle.shopping"
			class="typography-s1-emp flex items-center justify-center gap-8px"
		>
			<div
				@click="updateTab('shipping')"
				class="flex min-w-[171px] cursor-pointer flex-col items-center justify-center gap-8px gap-8px rounded-t-lg px-16px py-[14px] mdp:flex-row mdp:px-24px mdp:py-[16px]"
				:class="currentTab === 'shipping' ? 'bg-white' : 'bg-t-50'"
			>
				<BaseIcon name="delivery_v3" class="h-24px w-24px" />
				<div class="text-center">{{ pageContent.banner.toggle.shipping }}</div>
			</div>
			<div
				@click="updateTab('shopping')"
				class="flex min-w-[171px] cursor-pointer flex-col items-center justify-center gap-8px rounded-t-lg px-16px py-[14px] mdp:flex-row mdp:px-24px mdp:py-[16px]"
				:class="currentTab === 'shopping' ? 'bg-white' : 'bg-o-50'"
			>
				<BaseIcon name="community_v3" class="h-24px w-24px" />
				<div class="text-center">{{ pageContent.banner.toggle.shopping }}</div>
			</div>
		</div>

		<picture
			class="absolute -left-[181px] top-1/2 hidden h-[712px] w-[362px] -translate-y-1/2 mdp:block"
		>
			<img
				class="h-full w-full object-contain"
				:srcset="`
						${getVueAssetImagePath('hero-section-insurance_left.png')}
					`"
				alt="hero section left"
			/>
		</picture>
		<picture
			class="absolute -right-[181px] top-1/2 hidden h-[712px] w-[362px] -translate-y-1/2 mdp:block"
		>
			<img
				class="h-full w-full object-contain"
				:srcset="`
						${getVueAssetImagePath('hero-section-insurance_right.png')}
					`"
				alt="hero section right"
			/>
		</picture>
	</div>
</template>
